// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"0d46c1b2","82":"310be23f","237":"7bb79ee3","354":"43b09a08","454":"756b1a7d","487":"7cb166c3","507":"166c334e","787":"28cb0dcd","810":"7e094355","836":"6a85f2c7","975":"c648bc65"}[chunkId] + ".chunk.js";
};